import React from 'react';
export function TermsFooter() {
  return <footer className="py-12 bg-beige border-t border-sage-light/20" data-id="element-227">
      <div className="px-4 mx-auto max-w-3xl sm:px-6 lg:px-8 text-center" data-id="element-228">
        <h3 className="mb-4 text-sm font-semibold text-charcoal/70 uppercase tracking-wider" data-id="element-229">
          Términos y Condiciones
        </h3>

        <div className="space-y-2 mb-10 text-xs text-charcoal/50" data-id="element-230">
          <p data-id="element-231">• El producto es digital</p>
          <p data-id="element-232">• El acceso se entrega inmediatamente después del pago</p>
          <p data-id="element-233">• El contenido es solo para uso personal</p>
          <p data-id="element-234">• No se permite redistribuir ni revender el material</p>
          <p data-id="element-235">• Política de garantía de 7 días</p>
        </div>

        <h3 className="mb-4 text-sm font-semibold text-charcoal/70 uppercase tracking-wider" data-id="element-236">
          Política de Privacidad
        </h3>

        <div className="space-y-2 mb-8 text-xs text-charcoal/50" data-id="element-237">
          <p data-id="element-238">
            • Recopilamos únicamente los datos necesarios para procesar tu
            compra (nombre, correo electrónico y datos de pago)
          </p>
          <p data-id="element-239">
            • Tu información personal no será compartida ni vendida a terceros
          </p>
          <p data-id="element-240">• Utilizamos medidas de seguridad para proteger tus datos</p>
          <p data-id="element-241">
            • Puedes solicitar la eliminación de tus datos en cualquier momento
            contactándonos por correo electrónico
          </p>
          <p data-id="element-242">
            • Al realizar tu compra, aceptas el uso de tus datos conforme a esta
            política
          </p>
        </div>

        <p className="text-xs text-charcoal/40" data-id="element-243">
          © {new Date().getFullYear()} Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}